<div class="container-fluid paddingright">
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12 col-12 col-sm-12 col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-between">
        <h1 class="fs-4 fw-bold mb-0">View Invoice</h1>
        <button class="btn btn-dark btn-sm" mat-raised-button matTooltip="Back" matTooltipPosition="left"
          (click)="backTo()">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item active" aria-current="page">Manage LR</li>

          <li class="breadcrumb-item active" aria-current="page">
            View Invoice
          </li>
        </ol>
      </nav>
    </div>
  </div>
  <div class="contentbox w-90vw mt-3">
    <form [formGroup]="filterform">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group accountsinp mb-3">
            <label for="">Company Name</label>
            <select id="clientNamectrl" formControlName="clientName" placeholder="Select Client"
              class="form-control shadow-none" (change)="onFocusGetLr($event)">
              <option value="">--Select Company Name--</option>
              <option *ngFor="let c of clientList" value="{{ c._id }}">
                {{ c.clientName }}
              </option>
            </select>
          </div>
        </div>
        <!-- <div class="col-md-4">
                    <div class="form-group accountsinp  mb-3">
                        <label for="">LR No.</label>
                        <select id="LR_noctrl" formControlName="LR_no" placeholder="Select LR"
                            class="form-control shadow-none">
                            <option value="" disabled>--Select LR No.--</option>
                            <option *ngFor="let r of lrNumber" value="{{r.item_text}}">{{r.item_text}}
                            </option>

                        </select>
                    </div>
                </div> -->

        <!-- =============== multi select lr number end =========================== -->
        <div class="col-md-4">
          <div class="form-group accountsinp mb-3">
            <label for="">Invoice Type</label>
            <select id="invoiceTypectrl" formControlName="invoiceType" placeholder="Select Invoice Type"
              class="form-control shadow-none">
              <option value="">--Select Invoice Type--</option>
              <option *ngFor="let s of invoiceType" value="{{ s.invoiceTypeName }}">
                {{ s.invoiceTypeName }}
              </option>
            </select>
          </div>
        </div>
        <!-- =============== multi select lr number =========================== -->
        <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
          <!-- <form [formGroup]="form"> -->
          <label for="">System LR No.<sup class="text-danger">*</sup></label>
          <div class="form-group accountsinp mb-3">
            <ng-multiselect-dropdown formControlName="LR_no" [placeholder]="'Select LR No.'"
              [settings]="dropdownSettings" [data]="lrNumber" (onSelect)="onItemSelect($event)">
            </ng-multiselect-dropdown>
          </div>
        </div>


        <div class="col-xl-12 text-end">
          <button class="btn btn-dark ms-2" type="button" mat-raised-button (click)="generateInvoicePreview()">
            Invoice Generate
          </button>
        </div>
      </div>
    </form>
  </div>

  <div class="contentbox w-90vw mt-3">
    <div class="row">
      <div class="col-xl-3 ms-auto">
        <input class="search-box form-control" #data placeholder="Search" type="text"
          (keyup)="filterData(data.value)" />
      </div>

      <div class="col-md-12">
        <div class="table-responsive">
          <!-- <table id="example" datatable [dtOptions]="dtOptions" class="row-border hover tablelist" *ngIf='invoiceList.length > 0'>
                        <thead>
                            <tr>

                                <td>Client Name</td>
                                <td>Date</td>
                                <td class="text-center">Action</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let client of clientName">
                                <td>
                                    {{client.clientName}}</td>
                                <td>
                                    {{client.date | date:'yyyy-MM-dd'}}</td>
                                <td>
                                    <div class="d-flex justify-content-center align-items-center">
                                        <button [routerLink]="['/superAdmin/lrmanagement/invoice', client._id]"
                                        class="btn btn-block"><i matTooltip="View" class="fa-solid fa-eye"></i></button>
                                        <button (click)="deleteInvoice(client._id)"
                                        class="btn btn-block"><i matTooltip="Delete" class="fa fa-trash"></i></button>
                                    </div>
                                </td>
                            
                            </tr>


                        </tbody>
                    </table> -->

          <table mat-table [dataSource]="dataSource" matSort matSortActive="created_date" matSortDirection="desc"
            (matSortChange)="sortData($event)" class="row-border hover tablelist">
            <ng-container matColumnDef="sno">
              <th mat-header-cell *matHeaderCellDef>S.no</th>
              <td mat-cell *matCellDef="let client; let i = index">
                {{ paginator.pageIndex * paginator.pageSize + (i + 1) }}
              </td>
            </ng-container>


            <ng-container matColumnDef="billNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Bill No
              </th>
              <td mat-cell *matCellDef="let client">{{ client?.billNumber }}</td>
            </ng-container>

            <ng-container matColumnDef="clientName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Company Name
              </th>
              <td mat-cell *matCellDef="let client">{{ client?.clientName }}</td>
            </ng-container>

            <!-- <ng-container matColumnDef="tripID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Trip ID
              </th>
              <td mat-cell *matCellDef="let client">{{ client.TripID}}</td>
            </ng-container> -->

            <ng-container matColumnDef="created_date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
              <td mat-cell *matCellDef="let client">
                {{ client.created_date | date : "yyyy-MM-dd" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="text-center">
                Action
              </th>
              <td mat-cell *matCellDef="let client">
                <div class="d-flex justify-content-center align-items-center">
                  <button [routerLink]="[
                      '/superAdmin/lrmanagement/invoice',
                      client._id
                    ]" class="btn btn-block">
                    <i matTooltip="View" class="fa-solid fa-eye"></i>
                  </button>
                  <button (click)="getParticularInvoice(client._id)" class="btn btn-block">
                    <i matTooltip="Print" class="fas fa-print"></i>
                  </button>
                  <button class="btn btn-block" (click)="sendInvoice('print-section', client._id)">
                    <i matTooltip="Send" class="fa fa-paper-plane"></i>
                  </button>
                  <button *ngIf="isAdmin" (click)="deleteInvoice(client._id)" class="btn btn-block">
                    <i matTooltip="Delete" class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          <mat-paginator #paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
          </mat-paginator>

          <!-- HIDDEN PRINT BUTTON FOR ngxPrint -->
          <button #printBtn [useExistingCss]="true" ngxPrint printSectionId="print-section"
            style="display: none;"></button>

          <div class="NewInvoice table-responsive" id="print-section" [style.display]="'none'">
            <table class="newInvoiceBox">
              <tr>
                <td class="py-3">
                  <table class="invoiceHead">
                    <tr>
                      <td>Transporter Name </td>
                      <td>: {{ transporterName || 'Radha Swami' }}</td>
                    </tr>
                    <tr>
                      <td>Company Address</td>
                      <td>: S 11 Block B, Sector-5, Sahni Tower, Rajender Nagar, Sahibabad, Ghaziabad, Ghaziabad, Uttar Pradesh – 201005</td>
                    </tr>
                    <tr *ngIf="transporterAddress && transporterAddress !== 'N/A'">
                      <td>Address</td>
                      <td>: {{ transporterAddress }}</td>
                    </tr>
                    <tr *ngIf="transporterGstNo && transporterGstNo !== 'N/A'">
                      <td>GST Number</td>
                      <td>: {{ transporterGstNo }}</td>
                    </tr>
                    <tr>
                      <td>Bill No </td>
                      <td>: {{ billno }}</td>
                    </tr>
                  </table>
                </td>
                <td class="text-end py-3">
                  <img src="../../../../assets/images/invoiceLogoDemo.png" width="200" alt="">
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <table class="invoiceDetails" *ngIf="users && users.length > 0">
                    <thead>
                      <!-- AD Hoc Header (with Manual LR No. restored) -->
                      <tr *ngIf="isAdHoc">
                        <td>Date</td>
                        <td>System LR No.</td>
                        <!-- <td>Manual LR No.</td> -->
                        <td>VEHICLE NO:</td>
                        <td>VEHICLE TYPE</td>
                        <td>From</td>
                        <td>TO</td>
                        <td>Freight</td>
                        <td>LABOUR LOADING</td>
                        <td>LABOUR UNLOADING</td>
                        <td>OTHER PAYMENTS</td>
                        <td>Detention</td>
                        <!-- <td>Toll & Parking</td> -->
                        <td>FINAL AMOUNT</td>
                      </tr>

                      <!-- Legacy / Fixed Header (with Manual LR No. and reading columns restored) -->
                      <tr *ngIf="!isAdHoc">
                        <td>Date</td>
                        <td>System LR No.</td>
                        <td>Manual LR No.</td>
                        <td>VEHICLE NO:</td>
                        <td>VEHICLE TYPE</td>
                        <td>From</td>
                        <td>TO</td>
                        <td>Freight</td>
                        <td>START READING</td>
                        <td>END.READING</td>
                        <td>KMR.</td>
                        <td>EXTRA HRS</td>
                        <td>Toll & Parking</td>
                        <td>AMOUNT</td>
                      </tr>
                    </thead>

                    <tbody *ngFor="let user of users; let uIndex = index">
                      <!-- AD Hoc Rows -->
                      <ng-container *ngIf="isAdHoc">
                        <tr *ngFor="let lr of user.LR_no; let i = index">
                          <td>{{ user.date[i] | date }}</td>
                          <td>{{ user.LR_no[i] }}</td>
                          <!-- <td>{{ user.manualLR_no?.[i] || '-' }}</td> -->
                          <td>{{ user.vehicle_id[i] }}</td>
                          <td>{{ getVehicleType(user, i) }}</td>
                          <td>{{ user.from[i] }}</td>
                          <td>{{ user.to[i] }}</td>
                          <td>{{ getFreight(user, i) }}</td>
                          <td>
                            <span>{{ (user.labourLoad && user.labourLoad[i] != null && user.labourLoad[i] !== '') ? user.labourLoad[i] : '-' }}</span>
                          </td>
                          <td>
                            <span>{{ (user.labourUnload && user.labourUnload[i] != null && user.labourUnload[i] !== '') ? user.labourUnload[i] : '-' }}</span>
                          </td>
                          <td>
                            <span>{{ (user.otherPayment && user.otherPayment[i] != null && user.otherPayment[i] !== '') ? user.otherPayment[i] : '-' }}</span>
                          </td>
                          <td>
                            <span>{{ (user.detention && user.detention[i] != null && user.detention[i] !== '') ? user.detention[i] : '-' }}</span>
                          </td>
                          <!-- <td>{{ user.tooltaxPaid[i] }}</td> -->
                          <td>{{ getAdhocLineAmount(user, i) | number:'1.2-2' }}</td>
                        </tr>

                        <tr>
                          <td class="footer">TOTAL</td>
                          <td class="footer">&nbsp;</td>
                          <!-- <td class="footer">&nbsp;</td> -->
                          <td class="footer">&nbsp;</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">{{ totLabourLoad | number:'1.2-2' }}</td>
                          <td class="footer">{{ totLabourUnload | number:'1.2-2' }}</td>
                          <td class="footer">{{ otherPayment | number:'1.2-2' }}</td>
                          <td class="footer">{{ totDetention | number:'1.2-2' }}</td>
                          <!-- <td class="footer">{{ tooltaxPaidtot | number:'1.2-2' }}</td> -->
                          <td class="footer">{{ totalAmountInAdhoc | number:'1.2-2' }}</td>
                        </tr>
<!-- 
                        <tr>
                          <td colspan="7"></td>
                          <td colspan="5" class="p-0">
                            <table class="extraText">
                              <tr>
                                <td>Total KM={{ kmtot }}</td>
                              </tr>
                              <tr>
                                <td>Detention={{ totDetention }}</td>
                              </tr>
                              <tr>
                                <td>Labour Loading={{ totLabourLoad }}</td>
                              </tr>
                              <tr>
                                <td>Labour Unloading={{ totLabourUnload }}</td>
                              </tr>
                              <tr>
                                <td>Toll & Parking={{ tooltaxPaidtot }}</td>
                              </tr>
                              <tr>
                                <td>Total={{ totalAmountInAdhoc | number:'1.2-2' }}</td>
                              </tr>
                            </table>
                          </td>
                        </tr> -->
                      </ng-container>

                      <!-- Legacy / Fixed Rows -->
                      <ng-container *ngIf="!isAdHoc">
                        <tr *ngFor="let lr of user.LR_no; let i = index">
                          <td>{{ user.date[i] | date }}</td>
                          <td>{{ user.LR_no[i] }}</td>
                          <td>{{ user.manualLR_no?.[i] || '-' }}</td>
                          <td>{{ user.vehicle_id[i] }}</td>
                          <td>{{ getVehicleType(user, i) }}</td>
                          <td>{{ user.from[i] }}</td>
                          <td>{{ user.to[i] }}</td>
                          <td>{{ getFreight(user, i) }}</td>
                          <td>{{ user.startmeterReading[i] }}</td>
                          <td>{{ user.endmeterReading[i] }}</td>
                          <td>{{ user.up_down_km[i] }}</td>
                          <td>{{ user.extrahour[i] }}</td>
                          <td>{{ user.tooltaxPaid[i] }}</td>
                          <td>{{ user.vehicleRate[i] }}</td>
                        </tr>

                        <tr>
                          <td class="footer">TOTAL</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">&nbsp;</td>
                          <td class="footer">{{ kmtot | number:'1.2-2' }}</td>
                          <td class="footer">{{ extrahour | number:'1.2-2' }}</td>
                          <td class="footer">{{ tooltaxPaidtot | number:'1.2-2' }}</td>
                          <td class="footer">{{ invtot | number:'1.2-2' }}</td>
                        </tr>

                        <tr>
                          <td colspan="9"></td>
                          <td colspan="5" class="p-0">
                            <table class="extraText">
                              <tr>
                                <td>Total KM={{ kmtot }}</td>
                              </tr>
                              <tr>
                                <td>Extra Hours={{ extrahour }}</td>
                              </tr>
                              <tr>
                                <td>Toll & Parking={{ tooltaxPaidtot }}</td>
                              </tr>
                              <tr>
                                <td>Total={{ invtot | number:'1.2-2' }}</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </ng-container>

                      <tr>
                        <td [attr.colspan]="isAdHoc ? 12 : 14"><b>{{ (isAdHoc ? totalAmountInAdhoc : invtot) | amountInWords }}</b></td>
                      </tr>
                    </tbody>

                  </table>
                  <table class="invoiceDetails" hidden>
                    <thead>
                      <tr>
                        <td>Date</td>
                        <td>Opening Reading </td>
                        <td>Closing Reading</td>
                        <td>Total KM</td>
                        <td>Start Time</td>
                        <td>End Time </td>
                        <td>Total Hours</td>
                        <td>Destination/Route</td>
                        <td>Toll </td>
                        <td> Parking</td>
                        <td>Value of Total Invoices</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01.11.2019</td>
                        <td>165690</td>
                        <td>165732</td>
                        <td>42</td>
                        <td>06.00AM</td>
                        <td>12.00PM </td>
                        <td>&nbsp;</td>
                        <td>CANNAUGHT PLACE</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>12573</td>
                      </tr>
                      <tr>
                        <td>01.11.2019</td>
                        <td>165690</td>
                        <td>165732</td>
                        <td>42</td>
                        <td>06.00AM</td>
                        <td>12.00PM </td>
                        <td>6</td>
                        <td>CANNAUGHT PLACE</td>
                        <td>230</td>
                        <td>&nbsp;</td>
                        <td>12573</td>
                      </tr>
                      <tr>
                        <td>01.11.2019</td>
                        <td>165690</td>
                        <td>165732</td>
                        <td>42</td>
                        <td>06.00AM</td>
                        <td>12.00PM </td>
                        <td>&nbsp;</td>
                        <td>CANNAUGHT PLACE</td>
                        <td>&nbsp;</td>
                        <td>40</td>
                        <td>12573</td>
                      </tr>
                      <tr>
                        <td class="footer">TOTAL</td>
                        <td class="footer">&nbsp;</td>
                        <td class="footer">&nbsp;</td>
                        <td class="footer">3997</td>
                        <td class="footer">&nbsp;</td>
                        <td class="footer">&nbsp;</td>
                        <td class="footer">65</td>
                        <td class="footer">&nbsp;</td>
                        <td class="footer">2370</td>
                        <td class="footer">1700</td>
                        <td class="footer">2182563</td>
                      </tr>
                    </tbody>

                  </table>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <p>We hereby confirmed that all the LR copies duly acknowledged by the customers have
                    been received and above details are found correct.
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <table class="signature">
                    <tr>
                      <td>
                        <p>Prepaired By</p>
                        <p>Name</p>
                        <p>Designation</p>
                      </td>
                      <td>
                        <p>Verified By</p>
                        <p>Name</p>
                        <p>Designation</p>
                      </td>
                      <td>
                        <p>Approved By</p>
                        <p>Name</p>
                        <p>Designation</p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>
</div>